<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <!--<preLoader v-if="loader"></preLoader>-->
        <div class="container">

            <CCard>
                <CCardHeader>
                        <router-link :to="{path: '/contact/create'}" class="btn btn-success btn-pill">
                            افزودن اطلاعات تماس
                         <small> (سرنخ/فرصت/{{$client}}/تامین‌کننده) </small>
                        </router-link>

                        <!--<button type="button" class="btn btn-info " data-toggle="modal" data-target="#groupSend">ارسال پیام-->
                        <!--گروهی </button>-->



                        <button type="button" class="btn btn-default" style="float: left"
                                v-on:click="tableToExcel('testTable', 'W3C Example Table')" >خروجی Excel </button>

                        <button  type="button" class="btn btn-info" data-toggle="modal" style="float: left;margin-left: 10px"
                                 data-target="#importExcel">
                            Import Excel</button>
                        <!--<button type="button" class="btn btn-default" style="float: left" v-print="'#printMe'" >پرینت لیست {{$customerLable}} ها</button>-->

                </CCardHeader>
                <CCardBody>


            <div class="panel panel-default ">
                <div class="panel-heading" >


                    <div class="row mb-4">
                        <div class="col-md-10">
                            <input type="text" v-model="search" @keyup="changeUpDown()" class="form-control input-search "
                                   placeholder="جستجو">
                        </div>
                        <div class="col-md-2">
                            <select class="select-search form-control" v-model="length" @change="changeUpDown()">
                                <option value="25" >25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>






                </div>
                <div class="panel-body  ">
                    <div class="table-responsive">

                        <table id="testTable" class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th >ثبت درخواست
<!--                                        {{ $t('Time booking') }}-->
                                    </th>
                                    <th class="position">
                                        <i style="cursor: pointer" v-if="orderIcon==`desc`" @click="changeUpDown(`personal_code`,`desc`)"
                                            class="fas fa-chevron-circle-up"></i>
                                        <i  style="cursor: pointer" v-else @click="changeUpDown(`personal_code`,`asc`)"
                                            class="fas fa-chevron-circle-down"></i>
                                        <small>کد سیستم</small> </th>

                                    <th class="position">
                                        <i style="cursor: pointer" v-if="orderIcon==`desc`" @click="changeUpDown(`code`,`desc`)"
                                           class="fas fa-chevron-circle-up"></i>
                                        <i  style="cursor: pointer" v-else @click="changeUpDown(`code`,`asc`)"
                                            class="fas fa-chevron-circle-down"></i>
                                        <small>کد رابط مالی</small> </th>


                                    <th class="position">

                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`first_name`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`first_name`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                        {{ $t('Name') }}</th>
                                    <th class="position">
                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`last_name`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`last_name`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                    {{ $t('surname') }}</th>
                                    <th class="position">{{ $t('phone/mobail') }}
                                        <i v-if="orderIcon==`desc`" @click="changeUpDown(`mobile`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else @click="changeUpDown(`mobile`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                    </th>
                                    <th>نوع</th>
                                    <th class="position"> {{ $t('Registration date') }}
                                        <i v-if="orderIcon==`desc`"  v-on:click="changeUpDown(`created_at`,`desc`)"
                                            class="fa  icon-form">&#xf102;</i>
                                        <i v-else v-on:click="changeUpDown(`created_at`,`asc`)"
                                            class="fa icon-form">&#xf103;</i>
                                    </th>
                                    <!--<th>{{ $t('Score') }} </th>-->
                                    <th> </th>
                                    <th> </th>
                                    <!--<th>{{ $t('SMS,E-mail') }}</th>-->

                                    <th width="100">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody  id="items" v-for="(item, index) in items" :key="index">
                                <tr data-toggle="collapse" :data-target="'#collapse-'+item.id" aria-expanded="false" :aria-controls="'#collapse-'+item.id">

                                    <td style="text-align: center">

                                        <button class="btn btn-sm btn-pill btn-outline-success" v-on:click="request(item.user_id)">
<!--                                           {{ $t('Submit request') }} -->
                                            ثبت پیش فاکتور
                                        </button>

                                    </td>
                                    <td><small>{{ item.personal_code }}</small></td>
                                    <td>{{ item.code }}</td>

                                    <td>{{ item.first_name }}</td>
                                    <td>{{ item.last_name }}</td>
                                    <td>{{ item.mobile }}</td>
                                    <td><b-badge v-text="contactType(item.type)"></b-badge></td>
                                    <td>{{ item.created_at| moment("dddd, jD jMMMM  ") }}</td>
                                    <!--<td>-->
                                        <!--<button type="button" class="btn btn-info btn-sm btn-pill" data-toggle="modal"-->
                                            <!--:data-target="`#myModal`+item.id">{{ $t('User (score) point') }}</button>-->

                                        <!--&lt;!&ndash; Modal &ndash;&gt;-->
                                        <!--<div :id="`myModal`+item.id" class="modal fade" role="dialog">-->
                                            <!--<div class="modal-dialog">-->

                                                <!--&lt;!&ndash; Modal content&ndash;&gt;-->
                                                <!--<div class="modal-content">-->
                                                    <!--<div class="modal-header">-->
                                                        <!--<button type="button" class="close"-->
                                                            <!--data-dismiss="modal">&times;</button>-->
                                                        <!--<h4 class="modal-title">{{ $t('Score') }}</h4>-->
                                                    <!--</div>-->
                                                    <!--<div class="modal-body">-->
                                                        <!--<div> {{ item.score }}: {{ $t('Score') }} ({{ item.first_name }}-->
                                                            <!--{{ item.last_name }} )</div>-->
                                                    <!--</div>-->
                                                    <!--<div class="modal-footer">-->
                                                        <!--<button type="button" class="btn btn-default"-->
                                                            <!--data-dismiss="modal">{{ $t('Close') }}</button>-->
                                                    <!--</div>-->
                                                <!--</div>-->

                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</td>-->
                                    <td>

                                        <!--<button class="badge badge-warning">{{$profileLable}} {{$customerLable}}</button>-->
                                        <router-link :to="{path: '/contact/profile/'+item.id, params: {id: item.id}}"
                                            class="btn btn-sm btn-pill btn-dark">
                                            پروفایل
                                        </router-link>

                                    </td>
                                    <!--<td> <button type="button" class="btn btn-info  btn-sm btn-pill" data-toggle="modal"-->
                                            <!--:data-target="'#'+item.id">{{ $t('Send message') }} </button></td>-->



                                    <td>

                                        <router-link  :to="{path: '/contact/edit/'+item.id, params: {id: item.id}}"
                                            class="btn  btn-sm btn-pill btn-outline-warning ">
                                          {{ $t('Edit') }}  
                                        </router-link >
                                    </td>
                                    <td>


                                    <a href="javascript: void(0)" class="btn btn-sm btn-pill btn-outline-danger"
                                            v-on:click="deleteEntry(item.id, index)">
                                           {{ $t('Delete') }} 
                                        </a>


<!--                                        <button class="btn btn-primary" type="button" data-toggle="collapse" :data-target="'#collapse-'+item.id" aria-expanded="false" :aria-controls="'#collapse-'+item.id">-->

<!--                                        </button>-->

                                    </td>





                                    <!--<p>-->
                                        <!--<a class="btn btn-primary" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">-->
                                            <!--Link with href-->
                                        <!--</a>-->
                                        <!---->
                                    <!--</p>-->





                                </tr>
                            <tr>
                                <td colspan="10" class="collapse" :id="'collapse-'+item.id">
                                    <div class="card card-body">
                                    </div>
                                </td>

                            </tr>


                                <!--<template v-for="item in items">-->
                                    <!--<tr></tr>-->
                                    <!--<tr class="detail-row"></tr>-->
                                <!--</template>-->
                            </tbody>
                        </table>

                        <!-- Button trigger modal -->
<!--                        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">-->
<!--                            Launch demo modal-->
<!--                        </button>-->

                        <!-- Modal -->
                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        ...
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        <button type="button" class="btn btn-primary">Save changes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
            <div class="col-xs-12 text-center">
                <pagination :api="'/api/contacts?search='+search+'&column='+col+'&length='+length+'&order='+orderMod" @pagnationChangeDate='pagnation'></pagination>

            </div>



                </CCardBody>
            </CCard>


        </div>




        <!-- Modal -->
        <div v-for="(item, index) in items" :key="index" :id="item.id" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">


                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">{{ $t('Send message') }}({{ $t('SMS, E-mail') }}) </h4>
                    </div>


                    <form v-on:submit.prevent="sendMessage(item.id)">


                        <div class="modal-body">
                            <div class="form-group">
                                <textarea v-model="item_message" class="form-control "></textarea>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal">{{ $t('Close') }}</button>
                            <button class="btn btn-success"> {{ $t('Send message') }}</button>

                        </div>

                    </form>

                </div>

            </div>

        </div>



        <div id="groupSend" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">{{ $t('Send message') }}({{ $t('SMS, E-mail') }}) </h4>
                    </div>

                    <form v-on:submit.prevent="sendGroupMessage()">

                        <div class="modal-body">

                            <div class="form-group">
                                <textarea v-model="message" class="form-control "></textarea>
                            </div>

                        </div>


                        <div class="modal-footer">
                            <button type="button" class="btn btn-default" data-dismiss="modal"> {{ $t('Close') }}</button>
                            <button class="btn btn-success"> {{ $t('Send message') }}</button>
                        </div>


                    </form>

                </div>

            </div>

        </div>




        <!-- Modal -->
        <div id="importExcel" class="modal fade " role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">


                    <form v-on:submit.prevent="getAttaches()">

                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                            <h4 class="modal-title"> Import Excel</h4>
                        </div>
                        <div class="modal-body">

                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <label class="control-label">Excel </label>
                                    <div class="form-group">
                                        <div class="input-group input-file" name="Fichier1">
                                            <input type="text" class="form-control" :placeholder="placeholder" />
                                            <input type="file" class="filestyle" ref="file" @change="onFileChangeNote($event)" />
                                            <span class="input-group-btn">
                                            <!--<button class="btn btn-default btn-choose" type="button">فایل</button>-->
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal"> {{ $t('Close') }}</button>
                            <button class="btn btn-primary" data-dismiss="modal" @click="saveAttach"> {{ $t('done') }} </button>
                        </div>


                    </form>

                </div>

            </div>
        </div>




    </div>






</template>


<script>



//    import axios from 'axios';

    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                items: [],
                loader: false,
                item_message: '',
                message: '',
                search: "",
                length: "",
                col: "",
                orderIcon: "",
                orderMod:'desc',

                order: {
                    message: '',
                    contact_ids: [],
                    sms: '1',
                    email: '1',
                    db: '1',


                },



                printObj: {
                    id: "printMe",
                    popTitle: 'good print',
                    extraCss: 'https://www.google.com,https://www.google.com',
                    extraHead: '<meta http-equiv="Content-Language" content="zh-cn"/>'
                },

                excel:{
                    file: '',

                },
                placeholder: '  انتخاب کنید',


                contacts: [],


            }
        },


        mounted() {
            this.loader = true

            axios
                .get('/api/contacts', this.auth)
                .then(response => {
                    this.items = response.data.data;
                    this.loader = false
                    console.log(this.items, "sss");

                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning('دسترسی شما برای این بخش محدود شده است');
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }

                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
        }


        ,
        methods: {
            changeUpDown(column, orderBY) {
                console.log(column,'orderBY',orderBY)
                let app = this
                // app.loader = true
                let col = column
                let orderMod = orderBY
                if (column == undefined || column == null) {
                    col = ""
                }
                if (orderBY == undefined || orderBY == null) {
                    orderMod = "asc"

                }
                if (orderBY == "asc") {
                    app.orderIcon = "desc"

                } else {
                    app.orderIcon = "asc"
                }
                console.log(app.orderIcon)
                setTimeout(function () {
                    axios
                        .get(
                            `/api/contacts?search=${app.search}&column=${col}&length=${app.length}&order=${orderMod}`,
                            app.auth)
                        .then(response => {
                            app.items = response.data.data;
                            // app.loader = false
                            console.log(app.items);

                        })
                        .catch(error => {
                            console.log(error);
                            // app.loader = false
                            app.errored = true
                        })
                        .finally(() => app.loading = false)
                }, 1000)
            },
            keysearch(search) {

                let app = this
                app.loader = true
                setTimeout(function () {
                    axios
                        .get(`/api/contacts?search=${search}`, app.auth)
                        .then(response => {
                            app.items = response.data.data;
                            app.loader = false
                            console.log(app.items);

                        })
                        .catch(error => {
                            console.log(error);
                            app.errored = true
                        })
                        .finally(() => app.loading = false)
                }, 1000)

            },
            pagnation(api) {
                // console.log(api,"m")
                axios.get(api, this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.items = response.data.data;
                        //  console.log(response.data.data)
                        // this.pagnationDate = response.data
                        //  console.log(this.pagnationDate)
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            request(id) {

                this.$router.push({
                    path: '/order/request/' + id,
                    params: {
                        id: id
                    }
                });

            },


            deleteEntry(id, index) {
                if (confirm("از حذف آیتم مطمئن هستید؟")) {
                    var app = this;
                    axios.delete('/api/contacts/' + id, app.auth)
                        .then(function (resp) {
                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            //                            alert("امکان حذف آیتم وجود ندارد");
                            app.$snotify.danger("امکان حذف آیتم وجود ندارد");
                        });
                }
            },


            sendMessage(item) {


                //                    this.success() ;
                var app = this;
app.loader=true
                app.order.message = app.item_message;
                app.order.contact_ids = [item];

                console.log(app.order);


                var newItem = app.order;
                axios.post('/api/contact/notify', newItem, app.auth)
                    .then(function (resp) {
                        //                        this.success();
                        app.$snotify.success("پیام با موفقیت ارسال شد");
                        console.log(resp.data.data);
app.loader=false
                    })
                    .catch(error => {
                        console.log(error);
                        app.loader=false
                        app.$snotify.error("دسترسی ارسال پیام وجود ندارد")
                    })

            },


            sendGroupMessage() {

                var app = this;
app.loader=true
                app.order.message = app.item_message;
                app.order.contact_ids = app.pluck(app.items, 'id');

                console.log(app.order);


                var newItem = app.order;
                axios.post('/api/contact/notify', newItem, app.auth)
                    .then(function (resp) {
app.loader=false
                        //                        this.success();
                        console.log(resp.data.data);
                        app.$snotify.success("پیام با موفقیت ارسال شد");


                    })
                    .catch(error => {
                        console.log(error);
                        app.loader=false
                        app.$snotify.error("دسترسی ارسال پیام وجود ندارد")
                    })


                console.log(app.message)

            },



            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },


            print() {
                 document.getElementById('printDiv').innerHTML.print();
//                window.print();
            },


             tableToExcel (table, name) {

                 var uri = 'data:application/vnd.ms-excel;base64,'
                     , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                     , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
                     , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }


                    if (!table.nodeType) table = document.getElementById(table)
                    var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
                    window.location.href = uri + base64(format(template, ctx))

            },













            onFileChangeNote(e) {
                this.excel.file = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.excel ,"note ch 144")
            },

            saveAttach() {
                var app = this;
                var newItem = app.excel;

                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                axios
                    .post(`/api/contactAdd/importExcel`,formData, app.auth)
                    //                axios.post('/api/services', formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));

//                    app.getAttaches()
//                    console.log(formData);


//                axios
//                    .get('/api/contacts', app.auth)
//                    .then(response => {
//                        app.items = response.data.data;
//
//                    })
//                    .catch(error => {
//                        app.loader = false
//                        console.log(error);
//                    })



                    })
                    .catch(function (e) {
                        console.log(e.response.data);

                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }
                    });





            },




            contactType(type){
                if (type == '1')
                    return 'سرنخ'
                else if (type == '2')
                    return 'فرصت'
              else if (type == '3')
                    return 'مشتری'
              else if (type == '4')
                    return 'تامین کننده '
              else if (type == '5')
                    return 'همکار/پیمانکار'
              else if (type == '6')
                    return ''
                else
                    return 'نامشخص'
            },








        }
    }








</script>
<style>

</style>
<!--<script>-->
<!--export default {-->
<!--computed: {-->
<!--username() {-->
<!--// We will see what `params` is shortly-->
<!--return this.$route.params.username-->
<!--}-->
<!--},-->
<!--methods: {-->
<!--goBack() {-->
<!--window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')-->
<!--}-->
<!--}-->
<!--}-->
<!--</script>-->
